import { Reveal, SectionHead } from "./Reveal";

const QA = [
    {
        q: "Czy webinarium jest bezpłatne?",
        a: "Tak, udział w webinarium jest całkowicie bezpłatny.",
    },
    {
        q: "Czy będzie nagranie?",
        a: "Tak. Nagranie otrzymają mailowo wszystkie zapisane osoby.",
    },
    {
        q: "Czy uczestnicy otrzymają certyfikat?",
        a: "Tak. Certyfikat również zostanie wysłany mailowo do wszystkich zapisanych osób.",
    },
];

export default function Faq() {
    return (
        <section className="py-16 sm:py-24 px-4 sm:px-8" data-testid="faq-section">
            <div className="max-w-3xl mx-auto">
                <SectionHead
                    index="06"
                    label="FAQ"
                    title="Najczęściej zadawane pytania"
                    center
                />
                <div className="mt-10 space-y-4">
                    {QA.map((item, i) => (
                        <Reveal key={item.q} delay={i * 0.08}>
                            <details
                                className="group rounded-3xl bg-white border border-brand-tint2 px-6 sm:px-8 py-5 shadow-[0_14px_35px_-22px_rgba(194,24,91,0.35)] open:border-brand transition-colors"
                                data-testid={`faq-item-${i + 1}`}
                            >
                                <summary className="flex items-center justify-between gap-4 cursor-pointer list-none text-base sm:text-lg font-bold text-brand-ink [&::-webkit-details-marker]:hidden">
                                    {item.q}
                                    <span className="grid place-items-center w-8 h-8 shrink-0 rounded-full bg-brand-tint text-brand-deep text-xl font-extrabold transition-transform duration-300 group-open:rotate-45">
                                        +
                                    </span>
                                </summary>
                                <p className="mt-4 text-sm sm:text-base leading-relaxed text-brand-gray">
                                    {item.a}
                                </p>
                            </details>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
